<template>
    <div class="banner_container" v-if="bannerList.length > 0">
        <img class="banner_img" :src="bannerList[0].address" alt />
    </div>
</template>

<script>
export default {
    data() {
        return {
            bannerList: [],
        };
    },
    components: {},
    created() {
        this.getBanner();
    },
    methods: {
        getBanner() {
            let data = { type: 9, isPublish: '1', current: 1, size: 10 };
            this.$api.picList(data).then((res) => {
                this.bannerList = res.data.list;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.banner_container {
    width: 1110px;
    height: 210px;
    margin: 0 auto;
    .banner_img {
        width: 1110px;
        height: 210px;
        object-fit: cover;
    }
}
</style>
